import { Component, OnInit, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { GlobalService } from '../../../../services/global.service';
import { LoginService } from '../../../../services/login.service';
import { Calculation } from '../../../../../classes/Calculations';

@Component({
  selector: 'project-breakdown-tab',
  templateUrl: './breakdown-tab.component.html',
  styleUrls: ['./breakdown-tab.component.scss']
})
export class BreakdownTabComponent implements OnInit {

  // Heights calculation for graphs
  graphHeights: any = {
    A: [
      [0, 0],
      [0, 0]
    ],
    B: [
      [0, 0],
      [0, 0]
    ],
    C: [
      [0, 0],
      [0, 0]
    ]
  };

  options_names = {
    'A': 'Option A',
    'B': 'Option B',
    'C': 'Option C'
  };

  @Input() permission: any = '';
  @Input() projectInfo: any = {};
  @Input() rebatesInfo: any[] = [];
  @Input() showInProposal: any[] = [];
  @Input() options: any = {};
  @Input() calculation: Calculation = new Calculation();
  @Input('projectID') id: number;


  constructor ( 
    public global: GlobalService,
    public loginService: LoginService
    ) { }

  ngOnInit ( ) {}

  ngOnChanges ( changes: SimpleChanges ) { 
    if ( changes['calculation'] ) {
      this.calculateHeights( );
    }
  }

  calculateHeights() {

    let options = ['A','B','C'];

    let calculation = this.calculation;
    let graphHeights = this.graphHeights;
    options.forEach( function( option ) {

      // First graph
      if ( calculation[option].existing_kWhs_number && calculation[option].proposed_kWhs_number ) {
        let _existing1 = +( calculation[option].existing_kWhs_number );
        let _proposed1 = +( calculation[option].proposed_kWhs_number );
        graphHeights[option][0][0] = 250 * _existing1 / ( _existing1 + _proposed1 );
        graphHeights[option][0][1] = 250 * _proposed1 / ( _existing1 + _proposed1 );
      }
      // Second graph
      if ( calculation[option].lifetime_kWh_existing_number && calculation[option].lifetime_kWh_proposed_number ) {
        let _existing2 = +( calculation[option].lifetime_kWh_existing_number );
        let _proposed2 = +( calculation[option].lifetime_kWh_proposed_number );
        graphHeights[option][1][0] = 250 * _existing2 / ( _existing2 + _proposed2 );
        graphHeights[option][1][1] = 250 * _proposed2 / ( _existing2 + _proposed2 );
      }
    });
    this.graphHeights = graphHeights;
  }
}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/projects/project/breakdown-tab/breakdown-tab.component.ts